import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import styles from './CollageBanner.module.scss'
import { itemRoute } from '../../utils/constants'
import { SaleItemInterface } from '../../types/interfaces'
import { getClusterImageUrl } from '../../utils/functions/getImageUri'
import { selectClusterList } from '../../../store/slices/clusterListSlice'

interface Props {
  items: SaleItemInterface[]
}

const POSITIONS = [
  'logo0', 'logo1', 'logo2', 'logo3', 'logo4', 'logo5',
  'logo6', 'logo7', 'logo8', 'logo9', 'logo10', 'logo11',
  'logo12', 'logo13', 'logo14', 'logo15', 'logo16', 'logo17',
  'logo18', 'logo19',
]

const shuffle = <T,>(arr: T[]): T[] => {
  const copy = [...arr]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy
}

// Функция для поиска первой картинки (не видео)
const getFirstImage = (files?: string[]) => {
  if (!files) return undefined
  const videoExts = ['.mp4', '.webm', '.mov', '.avi']
  return files.find((f) => !videoExts.some((ext) => f.toLowerCase().endsWith(ext)))
}

export const CollageBanner: React.FC<Props> = ({ items }) => {
  const clusters = useSelector(selectClusterList)
  const shuffledPositions = useMemo(() => shuffle(POSITIONS), [])
  const shuffledItems = useMemo(() => shuffle(items), [items])

  return (
    <section className={styles.Banner}>
      <div className={styles.Blur} />
      <h1 className={styles.Title}>ПОКУПАЙ НАПРЯМУЮ У ПРОДАВЦОВ</h1>

      <div className={styles.Collage}>
        {shuffledItems.map((item, i) => {
          const cluster = clusters.find((c) => c.id === item.clusterId)
          // Берем первую картинку (без видео)
          const firstImage = getFirstImage(item.files)
          const hasImage = firstImage && cluster

          return (
            <Link
              key={item.id}
              to={itemRoute(item.id)}
              className={`${styles.Card} ${
                styles[shuffledPositions[i % shuffledPositions.length]]
              }`}
            >
              {hasImage ? (
                <img
                  src={getClusterImageUrl(cluster, firstImage)}
                  alt={item.name}
                  className={styles.Image}
                  loading="lazy"
                />
              ) : (
                <div className={styles.Placeholder} />
              )}

              {cluster && (
                <div className={styles.ClusterBadge}>
                  <img
                    src={`https://${cluster.domain}/icons/logo512.png`}
                    alt={cluster.name}
                  />
                </div>
              )}
            </Link>
          )
        })}
      </div>
    </section>
  )
}